﻿package org.zq.pixelset.theme

import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

/** 布局断点：紧凑（手机）、中等（平板）、宽屏（桌面） */
enum class WindowSizeClass {
    Compact,
    Medium,
    Expanded,
}

fun windowSizeClass(width: Dp): WindowSizeClass = when {
    width < 640.dp -> WindowSizeClass.Compact
    width < 960.dp -> WindowSizeClass.Medium
    else -> WindowSizeClass.Expanded
}

fun WindowSizeClass.isCompact(): Boolean = this == WindowSizeClass.Compact

fun WindowSizeClass.horizontalPadding(): Dp = when (this) {
    WindowSizeClass.Compact -> 16.dp
    WindowSizeClass.Medium -> 20.dp
    WindowSizeClass.Expanded -> 24.dp
}

fun WindowSizeClass.sidebarWidth(): Dp = when (this) {
    WindowSizeClass.Compact -> Dp.Unspecified
    WindowSizeClass.Medium -> 240.dp
    WindowSizeClass.Expanded -> 260.dp
}

fun WindowSizeClass.comparisonHeight(): Dp = when (this) {
    WindowSizeClass.Compact -> 220.dp
    WindowSizeClass.Medium -> 280.dp
    WindowSizeClass.Expanded -> 320.dp
}

fun WindowSizeClass.uploadZoneHeight(): Dp = when (this) {
    WindowSizeClass.Compact -> 120.dp
    WindowSizeClass.Medium -> 140.dp
    WindowSizeClass.Expanded -> 160.dp
}

fun WindowSizeClass.fileListMaxHeight(): Dp = when (this) {
    WindowSizeClass.Compact -> 240.dp
    WindowSizeClass.Medium -> 320.dp
    WindowSizeClass.Expanded -> 480.dp
}
